import { render } from "./catalog.cattle.io.clusterrepo.vue?vue&type=template&id=151f21b1&scoped=true&ts=true"
import script from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"
export * from "./catalog.cattle.io.clusterrepo.vue?vue&type=script&lang=ts"

import "./catalog.cattle.io.clusterrepo.vue?vue&type=style&index=0&id=151f21b1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151f21b1"]])

export default __exports__